<div [ngClass]="extraClasses">
  <router-outlet></router-outlet>
</div>

<app-toast-container aria-live="polite" aria-atomic="true" />

<!--Pdf Template-->
<ng-template appPdfPreview>
  <app-pdf-preview-template></app-pdf-preview-template>
</ng-template>

<div
  style="
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
  "
>
  <img
    style="height: 120px"
    class="move"
    [class.animate]="santaOn"
    src="/assets/images/santa.gif"
    alt=""
  />
</div>
